import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';

export const CarouselSectionLandscapeImageStyle: MediaSetting[] = [
  {
    screen: Screen.XXXS,
    key: '16_9_540',
    width: 540,
    height: 304,
    ratio: 1.78,
  },
  {
    screen: Screen.XL,
    key: '16_9_616',
    width: 720,
    height: 405,
    ratio: 1.78,
  },
];
